import { render, staticRenderFns } from "./progressCircle.vue?vue&type=template&id=2a63fc50&scoped=true&"
import script from "./progressCircle.vue?vue&type=script&lang=ts&"
export * from "./progressCircle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a63fc50",
  null
  
)

export default component.exports